import { createFileRoute, Link } from "@tanstack/react-router";
import { EmptyState } from "@/components/ui";

/**
 * Auffangroute für alles, was es nicht gibt.
 *
 * Sie liegt bewusst **unter** `_angemeldet` und nicht auf der Wurzel: Damit
 * läuft auch ein erfundener Pfad zuerst durch den Guard. Wer nicht angemeldet
 * ist, landet auf der Anmeldeseite statt auf einer Seite, die verrät, dass es
 * hier überhaupt etwas gibt.
 */
export const Route = createFileRoute("/_angemeldet/$")({
	component: NichtGefunden,
});

function NichtGefunden() {
	return (
		<div className="card">
			<EmptyState
				icon="search"
				title="Diese Seite gibt es nicht"
				hint="Vielleicht ist der Link veraltet oder hat sich ein Tippfehler eingeschlichen."
				action={
					<Link to="/" className="btn-primary">
						Zurück zur Startseite
					</Link>
				}
			/>
		</div>
	);
}
